import { ArrowRightOutlined } from '@ant-design/icons';
import clsx from 'clsx';
import React from 'react';

interface Step2TeamSizeProps {
  selectedSize: string;
  onSelect: (size: string) => void;
  onNext: () => void;
  loading?: boolean;
}

const TEAM_SIZES = [
  { range: '1-10', label: 'Employees' },
  { range: '11-50', label: 'Employees' },
  { range: '51-200', label: 'Employees' },
  { range: '201-500', label: 'Employees' },
  { range: '500+', label: 'Employees' },
];

const Step2TeamSize: React.FC<Step2TeamSizeProps> = ({
  selectedSize,
  onSelect,
  onNext,
  loading = false,
}) => {
  return (
    <div className='flex flex-col items-center text-center'>
      <h1 className='text-2xl md:text-3xl font-bold text-white tracking-tight mb-2'>
        How many team members are you looking to onboard?
      </h1>
      <p className='text-sm text-grayZl-400 mb-8 max-w-md'>
        Choose a range to help us estimate your initial setup.
      </p>

      {/* Cards Grid */}
      <div className='grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-3 max-w-2xl mb-10 w-full'>
        {TEAM_SIZES.map((tier) => {
          const isSelected = selectedSize === tier.range || selectedSize === tier.range.replace('-', '–');
          return (
            <button
              key={tier.range}
              type='button'
              onClick={() => onSelect(tier.range)}
              className={clsx(
                'group flex flex-col items-center justify-center p-4 rounded-xl border transition-all duration-150 cursor-pointer min-h-[90px] active:scale-95',
                isSelected
                  ? 'bg-[#151515] border-[#FF5612] shadow-[0_0_15px_rgba(255,86,18,0.2)]'
                  : 'bg-[#121212] border-[#262626] hover:border-neutral-600 hover:bg-[#181818]',
              )}
            >
              <span
                className={clsx(
                  'text-base md:text-lg font-bold tracking-tight mb-0.5 transition-colors',
                  isSelected ? 'text-[#FF5612]' : 'text-white group-hover:text-grayZl-100',
                )}
              >
                {tier.range}
              </span>
              <span
                className={clsx(
                  'text-xs transition-colors',
                  isSelected ? 'text-[#FF5612]/90' : 'text-grayZl-400',
                )}
              >
                {tier.label}
              </span>
            </button>
          );
        })}
      </div>

      <p className='text-xs text-grayZl-400 mb-6'>
        You can add or remove employees anytime.
      </p>

      <button
        type='button'
        onClick={onNext}
        disabled={!selectedSize || loading}
        className='px-8 h-12 bg-[#FF5612] hover:bg-[#E54D10] disabled:opacity-50 disabled:cursor-not-allowed text-white font-semibold rounded-xl text-sm transition-all duration-150 flex items-center justify-center gap-2 shadow-lg cursor-pointer active:scale-98'
      >
        <span>{loading ? 'Saving...' : 'Continue'}</span>
        <ArrowRightOutlined className='text-xs' />
      </button>
    </div>
  );
};

export default Step2TeamSize;
